<template>
  <div>
    <chart-column :title="title" :color="color" :data="data" :total="total"/>
  </div>
</template>

<script>
import ChartColumn from '@/components/Finance/Dashboard/ChartColumn/ChartColumn'

export default {
  name: 'ChartBalanceOfPartners',
  components: {
    ChartColumn
  },
  props: ['data', 'total'],
  data () {
    return {
      title: 'BALANCE OF PARTNERS',
      color: '#51D757'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Finance/Dashboard/BalanceOfPartners/ChartBalanceOfPartners.vue